<template>
  <div class="section container">
    <!-- <hr> -->
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon section-icon-linked-services" :class="brandClass()"></div>
        <h3 class="section-title-label">
          {{$t("profile_account_data_linked_services_title")}}
        </h3>
      </div>
    </div>
    <div>
      <div class="section-sub-header" v-if="linkedAccountsPreventingDeletion.length">
        <div>
          {{$t("profile_account_data_linked_services_deletion_linked_account")}}
        </div>
        <div class="linked-account-lists">
          <div v-for="(account, index) in linkedAccountsPreventingDeletion" :key="`linked-account-${index}`">
            {{$t(account.translationKey)}}
          </div>
        </div>
      </div>
      <div v-else class="section-sub-header">
          {{$t("profile_account_data_linked_services_no_linked_account")}}
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  inject:['$c', '$t', 'brandClass'],
  name: "ProfileLinkedServices",
  components: {
  },
  //validations from vuelidate
  props: {
    user: {},
  },
  data: () => ({
  }),
  computed:{
    /**
     * Return linked account if exists
     */
    linkedAccountsPreventingDeletion(){
      const toReturn = [];
      if(!this.user.linkedAccounts) return toReturn;
      for (const linked of this.user.linkedAccounts) {
        const linkedAccount = this.$c('list_of_linked_accounts').filter(a=>a.key==linked.type);
        if (linkedAccount && linkedAccount.length){
          toReturn.push(linkedAccount[0]);
        };
      }
      return toReturn;
    }
  },
  methods: {
  },
});
</script>

<style lang="scss" scoped>
.linked-account-lists {
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: bold;
}

.section-icon-linked-services {
  background-size: 95%;
  background-image: url('~@/assets/default/light/services-default-light.svg');    
  &.__d{
    background-image: url('~@/assets/default/dark/services-default-dark.svg');
  }                      
}
</style>